// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Icon from "../images-and-icons/Icon.res.js";
import * as Hover from "../../primitives/Hover.res.js";
import * as FontSizes from "../theme/FontSizes.res.js";
import * as Touchable from "../../primitives/Touchable.res.js";
import * as Stylex from "@stylexjs/stylex";
import * as JsxRuntime from "react/jsx-runtime";
let styles = {
  main: {
    "color-kMwMTN": "color-xbp64b2",
    "font-kVVagm": "font-x1t20fxh",
    "letterSpacing-kb6lSQ": "letterSpacing-x1owzkzt",
    $$css: "wino-gc:src/resources/actions/TextAction.res.js:11"
  },
  highlighted: {
    "color-kMwMTN": "color-x1lewwgq",
    $$css: "wino-gc:src/resources/actions/TextAction.res.js:16"
  },
  hovered: {
    "color-kMwMTN": "color-x1lewwgq",
    "textDecorationLine-kMnn75": "textDecorationLine-xujl8zx",
    $$css: "wino-gc:src/resources/actions/TextAction.res.js:19"
  }
};
function styleFromParams(highlighted, hovered, size) {
  return Stylex.props(styles.main, highlighted ? hovered ? styles.hovered : styles.highlighted : hovered ? styles.hovered : {}, size === "normal" ? {
    fontSize: FontSizes.toPx("normal")
  } : {
    fontSize: FontSizes.toPx("xsmall")
  });
}
function iconStyleFromParams(size) {
  return {
    0: {
      className: "textDecorationLine-xkrqix3 verticalAlign-x16dsc37 display-x1rg5ohu marginLeft-x1iog12x",
      "data-style-src": "wino-gc:src/resources/actions/TextAction.res.js:23; wino-gc:src/resources/actions/TextAction.res.js:31"
    },
    1: {
      className: "textDecorationLine-xkrqix3 verticalAlign-x16dsc37 display-x1rg5ohu marginLeft-x16vho4v",
      "data-style-src": "wino-gc:src/resources/actions/TextAction.res.js:23; wino-gc:src/resources/actions/TextAction.res.js:28"
    }
  }[!!(size === "normal") << 0];
}
function colorFromParams(highlighted, hovered) {
  if (highlighted || hovered) {
    return "#a01e72";
  } else {
    return "#25243a";
  }
}
function TextAction(props) {
  let onPress = props.onPress;
  let __trailingIcon = props.trailingIcon;
  let __highlighted = props.highlighted;
  let __size = props.size;
  let size = __size !== undefined ? __size : "normal";
  let highlighted = __highlighted !== undefined ? __highlighted : false;
  let trailingIcon = __trailingIcon !== undefined ? __trailingIcon : "help_center";
  let match = Hover.use(undefined, undefined, undefined);
  let hovered = match[1];
  let newrecord = {
    ...styleFromParams(highlighted, hovered, size)
  };
  let newrecord$1 = {
    ...iconStyleFromParams(size)
  };
  newrecord.children = [props.text, JsxRuntime.jsx("span", (newrecord$1.children = JsxRuntime.jsx(Icon.make, {
    name: trailingIcon,
    fill: colorFromParams(highlighted, hovered),
    width: size === "normal" ? 14 : 12,
    height: size === "normal" ? 14 : 12,
    bold: true
  }), newrecord$1))];
  return JsxRuntime.jsx(Touchable.make, {
    children: JsxRuntime.jsxs("span", newrecord),
    wrap: false,
    onPress: param => onPress(),
    ref: match[0]
  });
}
let make = TextAction;
export { make };
/* styles Not a pure module */